import { FormInstance } from "../Model/FormInstance";
import { v4 as uuidv4 } from 'uuid';
export class FormInstancesFactory {
    constructor(eventsChannelsFactory, formMembersFactory) {
        this.eventsChannelsFactory = eventsChannelsFactory;
        this.formMembersFactory = formMembersFactory;
    }
    createFormInstance(formId, instanceId = uuidv4(), sectionInstances = [], isFinished = false, dateCreated = new Date, dateCompleted = null) {
        const eventsChannel = this.eventsChannelsFactory.createEventsChannel(instanceId);
        return new FormInstance(eventsChannel, this.formMembersFactory, instanceId, formId, sectionInstances, isFinished, dateCreated, dateCompleted);
    }
}
